module.exports = ".ag-material .ag-row-odd {\n  background-color: #ffffff; }\n\n.ag-material .ag-root {\n  border: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/table-display/table-display.component.scss
// module id = ./src/app/shared/components/widgets/table-display/table-display.component.scss
// module chunks = main